export const TOGGLE_AUTHORIZATION_POPUP = 'TOGGLE_FANCY_NUMBER_ORDER_POPUP';
export const SET_AUTHORIZATION_POPUP_VALUE = 'SET_AUTHORIZATION_POPUP_VALUE';
